import { useEffect, useState } from 'preact/hooks';
import { loadCovers } from '../shelves/load';

/**
 * Covers for the book rows a table is showing (check-up, Kristi Nov 2: a table row that is a book
 * shows its cover). Loads only rows it hasn't seen; `undefined` while loading, `null` for none.
 */
export function useCovers(books: { id: string; workId: string }[]): Map<string, string | null> {
  const [covers, setCovers] = useState<Map<string, string | null>>(new Map());
  const key = books.map((b) => b.id).join(',');
  useEffect(() => {
    const missing = books.filter((b) => !covers.has(b.id));
    if (!missing.length) return;
    let live = true;
    loadCovers(missing)
      .then((m) => live && setCovers((old) => new Map([...old, ...m])))
      .catch(() => null);
    return () => {
      live = false;
    };
  }, [key]);
  return covers;
}
